/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect,useRef } from "react";
import InfoIndicatorCard from './InfoIndicator/InfoIndicatorCard';
import HeaderCount from './HeaderCount';
import { useAuthState } from '@bamboobox/b2logincheck';
import { useLocation } from "react-router-dom";
import { useParams } from 'react-router-dom';
import CreateTab from "./Tab"
import { Segments } from "../apis/api";
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import './Header.css'
import config from "../config.json";
import { getPermissionsForCards, getSessionPermissionsForCards } from "../helpers/permissionForCards.helper";
import { NetNewAccount } from "./childCardComponents/NetNewAccount2/NetNewAccount";

const useStyles = makeStyles({
  button: {
    border: 'none',
    fontFamily: 'Inter',
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px !important",
    lineHeight: "15px",
    color: "#3D70D4",
    textTransform: "none !important",
    '&:hover': {
      textDecoration: 'underline',
    },
  },
},
);

const Header = (props) => {
    let location = useLocation();

    function useQuery() {
        return new URLSearchParams(location.search);
    }

    let GetSegment = () => {
        return useQuery().get("segmentName");
    }
    const containerRef = useRef(null);

    const handleScrollToCard = () => {
      const cardPosition = document.getElementsByClassName ('mainHeader').offsetTop;
      containerRef.current.scrollTo({
        top: cardPosition+100,
        behavior: 'smooth',
      });
    };
  
    let { id } = useParams();
    let query = useQuery();
    let params_url = query.get("icp") || "";
    let category = query.get("category") || "";
    const [loglist,setLoglist] = useState([{ id: 2, listTitle: "All Accounts", type: 'account' }, { id: 1, listTitle: 'Target - CRM', type: 'account' }, { id: 0, listTitle: 'Target - Net New', type: 'account' }])
    const [tabVal,setTabVal] = useState(config.categories.indexOf(category) >=0 ? config.categories.indexOf(category): 0);
    console.log("TabVal70",tabVal)
    const [intentNewAccount, setIntentNewAccount] = useState(false);
    const[accSegment,setAccSegment]=useState("");
    const userDetails = useAuthState();
    const tenantId = userDetails.user.tenantId;
    console.log("tenantId59",tenantId)
    const userUuid = useAuthState().user.userUuid;
    const [body, setBody] = useState(id ? JSON.parse(decodeURIComponent(id)) : []);
    const [icp, setIcp] = useState(params_url);
    const classes = useStyles();
    const [isNetNew, setIsNetNew] = useState(false);
    const [isNetNewEnabled, setIsNetNewEnabled] = useState();

    if(window?.pendo && typeof window.pendo?.isReady === 'function' && !window.pendo.isReady()) {
      window.pendo.initialize({
        visitor: {
          id: userDetails.user.email,
          name:userDetails.user.name
        },
        account: {
          id: userDetails.user.tenantId,
          name: userDetails.user.tenantName
        }
      });
    }

    const getPermissionsForCardsApi = async () => {
      const permissionsForCards = getSessionPermissionsForCards();
      
      if (!permissionsForCards || permissionsForCards === null)
        userDetails?.permissions?.length > 0
          ? await getPermissionsForCards(
              userDetails.permissions.filter((perm) => perm.resourceName === "account_action_labels" || perm.resourceName === "contact_action_labels"),
              userDetails.user.tenantId
            )
          : await getPermissionsForCards("default", userDetails.user.tenantId);
    };

    function checkPermision(permissions, resourceNames) {
      for (var objIdx = 0; objIdx < permissions.length; objIdx++) {
        if (permissions[objIdx]?.operations?.length > 0 && resourceNames.includes(permissions[objIdx]?.resourceName)) {
          return setIsNetNew(true);
        };
      }
    };

    const checkNetNewEnabled = async () => {
    if (isNetNewEnabled) return;
    const requestBody = {
      tenantId: tenantId,
      tool: "netNewHub",
      keys: ["isEnabled"],
    };
    const response = await fetch(`${window._env_.TENANT_CONFIG}/tenant/get-tenant-config`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
      credentials: "include",
    });
    const result = await response.json();
    if (result.length > 0) {
      if (result[0].configVal === "true" || result[0].configVal === true) {
        return setIsNetNewEnabled(true);
      } else return setIsNetNewEnabled(false);
    }
  }

    useEffect(() => {
        let segName = GetSegment();
        console.log("segName",segName);
        if(segName && Array.isArray(loglist) && loglist?.filter(fil => fil?.listTitle === segName && fil?.type === 'account').length) {
          setAccSegment(segName)
        }
    }, [useQuery().get("segmentName"),loglist])

    useEffect(async () => {
      console.log("calling....")
      const segments = await Segments(tenantId, userUuid);
      if (Array.isArray(segments)) setLoglist(segments);
      getPermissionsForCardsApi().catch((error) => console.error("Error in getPermissionsForCardsApi", error));
      /* check resource for net-new */
      checkPermision(userDetails?.permissions, "net_new");
      checkNetNewEnabled();
    },[]);

    let GetIcp = () => {
      return useQuery().get("icp") || '';
  }

  useEffect(() => {
      console.log("test icp query changed")
      setIcp(GetIcp())
  }, [useQuery().get("icp")])

  const handleButtonClick = () => {
      setTabVal(1)
      handleScrollToCard()
  };

    console.log("header82", icp, accSegment)

    return (
      <div className="mainHeader" ref={containerRef}>
        <HeaderCount
          reqBody={body}
          icpSelected={icp}
          segmentName={accSegment}
          setIntentNewAccount={setIntentNewAccount}
          intentNewAccount={intentNewAccount}
          loglist={loglist}
          accSegment={accSegment}
          setAccSegment={setAccSegment}
          tabVal={tabVal}
        />
        <div className="compareButton">
          <Button
            className={classes.button}
            style={{ fontSize: "12px", fontWeight: 400, paddingRight: 0, color: "#3D70D4", backgroundColor: "transparent", "&:hover": { backgroundColor: "transparent", textDecoration: "underline" } }}
            onClick={handleButtonClick}
          >
            View Funnel Comparison
          </Button>
        </div>
        <div style={{ width: "100%", display: "flex", gap: "24px", height: (isNetNewEnabled && isNetNew) ? "300px" : "130px" }}>
          <InfoIndicatorCard
            reqBody={body}
            icpSelected={icp}
            segmentName={accSegment}
            setIntentNewAccount={setIntentNewAccount}
            intentNewAccount={intentNewAccount}
            loglist={loglist}
            accSegment={accSegment}
            setAccSegment={setAccSegment}
            tabVal={tabVal}
            isNetNew={isNetNew}
            isNetNewEnabled={isNetNewEnabled}
          />
          {(isNetNewEnabled && isNetNew) && (
            <NetNewAccount
              icpSelected={icp}
              segmentName={accSegment}
              tabVal={tabVal}
              tenantId={tenantId}
            />
          )}
        </div>
        <CreateTab tabVal={tabVal} setTabVal={setTabVal} segmentName={accSegment} tenantId={tenantId} requestBody={body} icpSelected={icp} setBody={setBody} body={body} />
      </div>
    );
}
    
export default Header